import React, { FC } from 'react';
import { Admin } from './admin';

const App: FC = () => <Admin />;

export default App;
